import * as React from 'react';
import { Body2, Image, UIHeading5 } from '@cian/ui-kit';

import * as style from './style.css';
import aber from './assets/Aber.svg';

export interface IAiBannerProps {
  title: string;
  subtitle: string;
}

export const AiBanner = ({ title, subtitle }: IAiBannerProps): React.JSX.Element => {
  return (
    <div className={style['container']} data-testid="ai-banner">
      <Image src={aber} height={40} width={54} preloader={false} />
      <div className={style['text-wrapper']}>
        <UIHeading5>{title}</UIHeading5>
        <Body2>{subtitle}</Body2>
      </div>
    </div>
  );
};
